"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Leading = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
var Leading_js_1 = require("./Leading.js");
Object.defineProperty(exports, "Leading", { enumerable: true, get: function () { return Leading_js_1.Leading; } });
exports.default = './Leading';
